
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/SupabaseAuthContext';
import { images } from '@/assets/images';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User, Settings, Activity, LogOut } from 'lucide-react';
import ProfileTabs from '@/components/profile/ProfileTabs';

const Profile: React.FC = () => {
  const { user, isLoading, signOut } = useAuth();
  const [activeTab, setActiveTab] = useState('profile');

  const updateProfile = async (data: any) => {
    // Profile update logic would go here
    console.log('Updating profile:', data);
  };

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="animate-pulse space-y-6">
            <div className="h-32 bg-slate-200 rounded-lg"></div>
            <div className="h-64 bg-slate-200 rounded-lg"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8 space-y-8">
      <div className="flex justify-center mb-6">
        <Link to="/dashboard" className="hover:scale-105 transition-transform duration-300">
          <img
            src={images.equiforgeLogoFlat}
            alt="EquiForge"
            className="h-12 md:h-14 w-auto object-contain drop-shadow-md"
          />
        </Link>
      </div>
      
      <div className="text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <User className="w-8 h-8 text-blue-600" />
          <h1 className="text-4xl font-bold">Profile</h1>
        </div>
        <p className="text-xl text-muted-foreground">
          Manage your account settings and preferences
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <ProfileTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          user={user}
          isLoading={isLoading}
          updateProfile={updateProfile}
          signOut={signOut}
        />
      </div>
    </div>
  );
};

export default Profile;
